function determineSupportsVantageSensorConfig(version) {
  // if version > 30.2.9
  if (!version) {
    return false;
  }
  version = version.split('.');
  if (version.length !== 3) {
    return false;
  }
  const major = parseInt(version[0]);
  const minor = parseInt(version[1]);
  const patch = parseInt(version[2]);
  return (major > 30 && major < 31) || (major === 30 && minor > 2) || (major === 30 && minor === 2 && patch >= 9);
}

function determineSupportsDataReport(version) {
  // if version > 30.2.9
  if (!version) {
    return false;
  }
  //version = version.split('.');
  //if (version.length !== 3) {
  //  return false;
  //}
  //const major = parseInt(version[0]);
  //const minor = parseInt(version[1]);
  //const patch = parseInt(version[2]);
  return determineSupportsVantageSensorConfig(version);
}

export { determineSupportsDataReport, determineSupportsVantageSensorConfig };
